import { forwardRef } from 'react'

const Checkbox = forwardRef(function Checkbox(
  { checked, onChange, label, disabled = false, ...rest },
  ref
) {
  return (
    <label
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 10,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        fontFamily: 'var(--font-body)',
        fontSize: 13,
        color: 'var(--olv-text-primary)',
      }}
    >
      <span
        style={{
          width: 16,
          height: 16,
          borderRadius: 4,
          background: checked ? 'var(--olv-purple)' : 'rgba(12,12,20,0.6)',
          border: `1px solid ${checked ? 'var(--olv-purple)' : 'rgba(255,255,255,0.12)'}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'all 200ms var(--ease-standard)',
          flexShrink: 0,
        }}
      >
        {checked && (
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
            <path d="M2 5l2 2 4-4" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        )}
      </span>
      <input
        ref={ref}
        type="checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        style={{ position: 'absolute', opacity: 0, pointerEvents: 'none' }}
        {...rest}
      />
      {label && <span>{label}</span>}
    </label>
  )
})

export default Checkbox
